import type { MascotEvent } from './mascot.reactions';

/**
 * A one-line way for any surface to tell the mascot that something happened.
 *
 * The alternative was threading a callback from the hero down through the calendar, the slot
 * strip and the CTA — three components that have no other reason to know a mascot exists.
 * Emitting is fire-and-forget: with no mascot mounted (or reduced motion on) nothing listens
 * and nothing happens, which is exactly the desired behaviour.
 */
type Listener = (event: MascotEvent) => void;

const listeners = new Set<Listener>();

export function emitMascotEvent(event: MascotEvent) {
  listeners.forEach(listener => listener(event));
}

export function onMascotEvent(listener: Listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}
